import { render } from "./pension-providers.vue?vue&type=template&id=3435db20&scoped=true"
import script from "./pension-providers.vue?vue&type=script&lang=js"
export * from "./pension-providers.vue?vue&type=script&lang=js"

import "./pension-providers.vue?vue&type=style&index=0&id=3435db20&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3435db20"]])

export default __exports__